module.exports = __webpack_public_path__ + "static/media/arrow-down.40f8d205.svg";